import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  extractAndStoreEconomicToken,
  getStoredEconomicToken,
  isEconomicIntegrationPath,
} from "./economicUtils";

export const useEconomicIntegration = () => {
  const [shouldRenderEconomicConnect, setShouldRenderEconomicConnect] =
    useState(false);
  const location = useLocation();

  useEffect(() => {
    const economicToken = getStoredEconomicToken();
    if (isEconomicIntegrationPath() || economicToken) {
      if (!economicToken) {
        extractAndStoreEconomicToken();
      }

      // We can be redirected to the economic integration path in two different scenarios:
      // 1. When a newly signed-up user presses the "connect to economic" button from within asktally.com
      //    In this case, the user is authenticated.
      // 2. When a user is redirected from the e-conomic market-place. In this case, the user
      //   is not authenticated, and we should not render the EconomicConnect component. Instead we
      //   redirect them to the sign-up process.
      const hasToken = localStorage.getItem("token");
      if (hasToken) {
        setShouldRenderEconomicConnect(true);
        return;
      }
      setShouldRenderEconomicConnect(false);
    } else {
      setShouldRenderEconomicConnect(false);
    }
  }, [location.pathname]);

  return {
    shouldRenderEconomicConnect,
    isEconomicIntegrationPath: isEconomicIntegrationPath(),
  };
};
